import React, { useEffect, useState, memo } from "react"

import { HeaderInternalSearchButton } from "components/structure-components/header/header-components"
import { InternalSearchModal } from "components/page-components/Internal-Search"
import { Link } from "gatsby"
import Logo from "assets/logo.svg"
import { getHeaderComponent } from "./utils"
import {
  header_components_desktop,
  header_components_mobile,
} from "data/header"

export const Header = memo(({ windowWidth, location }) => {
  const [search_modal_active, set_search_modal_active] = useState(false)

  const open_search_modal = () => {
    window.history.replaceState(
      {},
      "",
      window?.location?.pathname + "#internal_search_open"
    )
    const { scrollY } = window
    Object.assign(document.body.style, {
      position: "fixed",
      top: `-${scrollY}px`,
      overflow: "hidden",
      width: "100vw",
    })
    set_search_modal_active(true)
  }

  const close_search_modal = (e) => {
    if (
      e.target.id === "search-modal-close-button" ||
      e.target.id === "search-modal-background"
    ) {
      window.history.replaceState({}, "", window?.location?.pathname)
    }
    const scrollY = document.body.style.top
    Object.assign(document.body.style, {
      position: "",
      top: "",
      overflow: "unset",
      width: "",
    })
    window.scrollTo(0, parseInt(scrollY || "0") * -1)
    set_search_modal_active(false)
  }

  useEffect(() => {
    window?.location?.hash === "#internal_search_open" &&
      !search_modal_active &&
      set_search_modal_active(true)
    return () => {
      const scrollY = document.body.style.top
      Object.assign(document.body.style, {
        position: "",
        top: "",
        width: "unset",
        overflow: "",
      })
      window.scrollTo(0, parseInt(scrollY || "0") * -1)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const [mobile_menu_active, set_mobile_menu_active] = useState(false)
  const [open_submenu, set_open_submenu] = useState(false)

  const toggle_mobile_menu = () => {
    if (!mobile_menu_active) {
      const { scrollY } = window
      Object.assign(document.body.style, {
        position: "fixed",
        top: `-${scrollY}px`,
        overflow: "hidden",
        width: "100vw",
      })
    } else {
      const scrollY = document.body.style.top
      Object.assign(document.body.style, {
        width: "unset",
        overflow: "",
        position: "",
        top: "",
      })
      window.scrollTo(0, parseInt(scrollY || "0") * -1)
    }
    set_mobile_menu_active(!mobile_menu_active)
  }

  return (
    <header
      data-nosnippet
      style={{
        width: "100%",
        backgroundColor: "white",
        height: 80,
      }}
    >
      <nav
        className={`navbar container`}
        role="navigation"
        aria-label="main navigation"
      >
        <div className="navbar-brand" style={{ height: "100%" }}>
          <div className="is-hidden-desktop">
            <HeaderInternalSearchButton {...{ location, open_search_modal }} />
          </div>

          <Link to={"/"} className="navbar-item navbar-logo m-auto">
            {windowWidth ? (
              <img
                src={
                  windowWidth < 1300 && windowWidth > 1023
                    ? "/assets/b-i-favicon-small.jpg"
                    : Logo
                }
                alt="Logo"
                style={
                  windowWidth > 1023 && windowWidth < 1300
                    ? { width: "auto", height: "auto" }
                    : { width: "150px", height: "22px" }
                }
              />
            ) : null}
          </Link>
          <button
            className={`is-hidden-desktop navbar-burger burger is-borderless mx-0 my-auto${
              mobile_menu_active ? " is-active" : ""
            }`}
            style={{ height: 80 }}
            onClick={toggle_mobile_menu}
            onKeyDown={() => {}}
            tabIndex={0}
            aria-label="menu toggle"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
        <div className={`navbar-menu${mobile_menu_active ? " is-active" : ""}`}>
          <div className="navbar-end is-hidden-touch">
            {header_components_desktop?.map((props, i) =>
              getHeaderComponent({
                ...props,
                react_key: "desktop-header-component-" + i,
                open_submenu,
                set_open_submenu,
                location,
                open_search_modal,
              })
            )}
          </div>
          <div className="navbar-end is-hidden-desktop">
            {header_components_mobile?.map((props, i) =>
              getHeaderComponent({
                ...props,
                react_key: "mobile-header-component-" + i,
                open_submenu,
                set_open_submenu,
                location,
                open_search_modal,
              })
            )}
          </div>
        </div>
      </nav>
      {search_modal_active ? (
        <InternalSearchModal
          {...{
            location: location,
            search_modal_active,
            close_search_modal,
          }}
        />
      ) : null}
    </header>
  )
})
